import React from 'react';
import TopBarBlock from './topbarBlock';
import './layout/allLayouts';
import { findIndex, sortBy } from 'underscore';
import clone from 'clone';
import url from '../../urlhandler/urlHandlerActions';
import classNames from 'classnames';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import HoverAction from '../action/hoverAction';
const $ = jQuery;

class GridBlock extends React.Component {
    constructor(props) {
      super(props);
      this.displayName = 'GridBlock';
      this.showAllPosts = this.showAllPosts.bind(this);
      this.handleLoadMore = this.handleLoadMore.bind(this);
      this.changePage = this.changePage.bind(this);
      this.isUrlChange = this.isUrlChange.bind(this);
      this.state = {
        'posts': this.props.previewOption ? this.props.previewOption.data : [],
        'showAnimatedMsg': this.props.previewOption.data === 0 ? 0 : 1,
        'pageNumber': 1,
        'loadedItem': 5,
        'filterable': this.props.settingsData.ajax === 'false' ? true : false,
        previousPosts: [],
        gridUrlData: clone(window.searchArray),
      };
    }
    componentWillMount() {
      const self = this;
      const index = findIndex(window.searchArray, { key: 'pagenumber' });
      if (index !== -1) {
        self.setState({ pageNumber: parseInt(window.searchArray[index].value, 10) });
      }
      const gridIndex = findIndex(self.props.allLayout, { type: 'grid' });
      if (gridIndex !== -1) {
        self.setState({
          loadedItem: self.props.allLayout[gridIndex].hasOwnProperty('numberOfPosts') ? parseInt(self.props.allLayout[gridIndex].numberOfPosts, 10) : 5 });
      }
    }

    componentWillReceiveProps(nextProps) {
      // const posts = clone(nextProps.previewOption.data);
      let posts = null;
      if (_.isArray(nextProps.previewOption.data)) {
        posts = clone(nextProps.previewOption.data);
      } else {
        posts = [];
      }
      const urlChangeFlag = clone(this.isUrlChange());
      const bottombar = nextProps.block.bottombar ? nextProps.block.bottombar : {};
      let bottomloadMore = false;
      if ('bottomloadMore' in bottombar) {
        bottomloadMore = bottombar.bottomloadMore;
      }
      const pageNumber = urlChangeFlag ? 1 : this.state.pageNumber;
      if (bottomloadMore === 'false') {
        bottomloadMore = false;
      }
      if (bottomloadMore === 'true') {
        bottomloadMore = true;
      }

      if (urlChangeFlag === true && nextProps.settingsData.ajax === 'false') { // non ajax
        const self = this;
        setTimeout(() => {
          self.setState({ pageNumber: 1, posts: [] });
          if (posts.length === 0) {
            self.setState({ showAnimatedMsg: 0 });
          } else {
            self.setState({ showAnimatedMsg: 1, posts });
          }
        }, 5);
        $('#LoadTime').fadeOut(300);
      } else {
        if (nextProps.settingsData.ajax === 'false') {
          $('#LoadTime').fadeOut(300);
        }
      }

      if (bottomloadMore) {
        let newPosts = [];
        if (pageNumber !== 1 && this.state.posts[0].ID !== posts[0].ID) {
          newPosts = this.state.posts.concat(posts);
        } else {
          newPosts = posts;
        }
        this.setState({
          filterable: nextProps.settingsData.ajax === 'false' ? true : false,
          posts: newPosts,
          showAnimatedMsg: newPosts.length === 0 ? 0 : 1,
          pageNumber,
        });
      } else {
        this.setState({
          'filterable': nextProps.settingsData.ajax === 'false' ? true : false,
          posts,
          showAnimatedMsg: posts.length === 0 ? 0 : 1,
          pageNumber,
        });
      }
    }
    isUrlChange() {
      const propsUrlData = clone(this.state.gridUrlData);
      const nextPropsUrlData = clone(window.searchArray);
      const indexOfPropsUrl = findIndex(propsUrlData, { key: 'pagenumber' });
      if (indexOfPropsUrl !== -1) {
        propsUrlData.splice(indexOfPropsUrl, 1);
      }
      const indexOfNextPropsUrl = findIndex(nextPropsUrlData, { key: 'pagenumber' });
      if (indexOfNextPropsUrl !== -1) {
        nextPropsUrlData.splice(indexOfNextPropsUrl, 1);
      }
      let flag = false;
      if (nextPropsUrlData.length < propsUrlData.length) {
        flag = true;
      }
      if (nextPropsUrlData.length === 0) {
        flag = true;
      }
      nextPropsUrlData.map((item) => {
        const index = findIndex(propsUrlData, { key: item.key });
        if (index === -1) {
          flag = true;
        } else {
          const tempKeyValue = [];
          for (let indexOfPropsUrlData = 0; indexOfPropsUrlData < propsUrlData.length; indexOfPropsUrlData++) {
            if (item.key === propsUrlData[indexOfPropsUrlData].key) {
              tempKeyValue.push(propsUrlData[indexOfPropsUrlData].value);
            }
          }
          if (_.indexOf(tempKeyValue, item.value) === -1) {
            flag = true;
          }
        }
      });
      this.setState({ gridUrlData: clone(window.searchArray) });
      if (propsUrlData.length === 0 && nextPropsUrlData.length === 0) {
        flag = false;
      }
      return flag;
    }

    showAllPosts(post, index) {
      let columnSize;
      let columnSizeList;
      let gridindex = findIndex(this.props.allLayout, {
        type: 'grid',
      });
      const isViewType = findIndex(window.searchArray, { key: 'view' });
      let viewTypeGrid = 'grid';
      if (isViewType !== -1) {
        viewTypeGrid = window.searchArray[isViewType].value;
      }
      if (gridindex !== -1) {
        if (viewTypeGrid === 'grid') {
          if (this.props.allLayout[gridindex].hasOwnProperty('column')) {
            columnSize = classNames({
              'flex-lg-12': this.props.allLayout[gridindex].column.grid_desktop_hd === '1',
              'flex-lg-6': this.props.allLayout[gridindex].column.grid_desktop_hd === '2',
              'flex-lg-4': this.props.allLayout[gridindex].column.grid_desktop_hd === '3',
              'flex-lg-3': this.props.allLayout[gridindex].column.grid_desktop_hd === '4',
              'flex-md-12': this.props.allLayout[gridindex].column.gird_desktop === '1',
              'flex-md-6': this.props.allLayout[gridindex].column.grid_desktop === '2',
              'flex-md-4': this.props.allLayout[gridindex].column.grid_desktop === '3',
              'flex-md-3': this.props.allLayout[gridindex].column.grid_desktop === '4',
              'flex-sm-6': this.props.allLayout[gridindex].column.grid_tablet === '2',
              'flex-sm-12': this.props.allLayout[gridindex].column.grid_tablet === '1',
              'flex-sm-4': this.props.allLayout[gridindex].column.grid_tablet === '3',
              'flex-xs-6': this.props.allLayout[gridindex].column.grid_mobile === '2',
              'flex-xs-12': this.props.allLayout[gridindex].column.grid_mobile === '1',
            });
          } else {
            gridindex = 0;
            columnSize = classNames({
              'flex-md-6': true,
              'flex-sm-6': true,
              'flex-xs-12': true,
            });
          }
        } else {
          if (this.props.allLayout[gridindex].hasOwnProperty('column')) {
            columnSizeList = classNames({
              'flex-lg-12': this.props.allLayout[gridindex].column.list_desktop_hd === '1',
              'flex-lg-6': this.props.allLayout[gridindex].column.list_desktop_hd === '2',
              'flex-md-12': this.props.allLayout[gridindex].column.list_desktop === '1',
              'flex-md-6': this.props.allLayout[gridindex].column.list_desktop === '2',
              'flex-sm-12': this.props.allLayout[gridindex].column.list_tablet === '1',
              'flex-xs-12': this.props.allLayout[gridindex].column.list_mobile === '1',
            });
          } else {
            columnSizeList = classNames({
              'flex-lg-6': true,
              'flex-md-6': true,
              'flex-sm-12': true,
              'flex-xs-12': true,
            });
          }
        }
      }
      const urlData = clone(this.props.urlData);
      const indexOfGrid = findIndex(this.props.allLayout, { type: 'grid' });
      let view = null;
      if (indexOfGrid !== -1) {
        view = this.props.allLayout[indexOfGrid].hasOwnProperty('viewType') ? this.props.allLayout[indexOfGrid].viewType : 'grid';
      }
      if (urlData.hasOwnProperty('view')) {
        view = urlData.view;
      }
      if (this.props.allLayout[indexOfGrid].previewLayouts !== undefined) {
        this.ComponentName = ReactiveTemplates[this.props.allLayout[indexOfGrid].previewLayouts];
      } else {
        // const componentFormat = 'doPost' + post.post_format.replace(/(^[a-z])/, (p) => { return p.toUpperCase(); });
        this.ComponentName = ReactiveTemplates.latestGridLayoutThree;
      }
      const transitionOption = {
        transitionName: 'fly',
        transitionEnterTimeout: 500,
        transitionAppearTimeout: 500,
        transitionLeaveTimeout: 300,
        transitionAppear: true,
      };

      return (<div className={ viewTypeGrid === 'grid' ? columnSize : columnSizeList } key={post.ID} >
        <ReactCSSTransitionGroup {...transitionOption}>
          <div className="check-post-effect" onMouseLeave={this.handleLeave.bind(this)} onMouseEnter={this.handleHover.bind(this, post)}>
            <this.ComponentName post={post} view={view} {...this.props}/>
          </div>
        </ReactCSSTransitionGroup>
      </div>);
    }
    handleLeave() {
      HoverAction.pushHoverData({
        hide: true,
      });
    }
    handleHover(post) {
      HoverAction.pushHoverData(post);
    }
    changePage(selectedPageNumber) {
      const pageNumber = parseInt(selectedPageNumber, 10);
      const posts = clone(this.state.posts);
      url.push({
        'searchItem': 'pagenumber',
        'searchType': 'globalSearch',
        'searchField': 'pagination',
        pageNumber,
      });
      const self = this;
      setTimeout(() => {
        self.setState({ posts: [] });
        self.setState({ pageNumber, posts });
      }, 5);
    }
    handleListenTopBar(data) {
      const posts = clone(this.state.posts);
      let newPosts = [];
      if ('sortAttr' in data) {
        if (data.sortAttr === 'post_title' || data.sortAttr === 'comment_count') {
          if (data.sortBy === 'desc') {
            newPosts = sortBy(posts, data.sortAttr).reverse();
          } else {
            newPosts = sortBy(posts, data.sortAttr);
          }
        } else if (data.sortAttr === 'post_date') {
          if (data.sortBy === 'desc') {
            newPosts = posts.sort((a, b) => {
              return new Date(b.post_date) - new Date(a.post_date);
            });
          } else {
            newPosts = posts.sort((a, b) => {
              return new Date(a.post_date) - new Date(b.post_date);
            });
          }
        } else {
          newPosts = posts.sort((a, b) => {
            if (data.sortBy === 'desc') {
              return b.meta[data.sortAttr] - a.meta[data.sortAttr];
            }
            return a.meta[data.sortAttr] - b.meta[data.sortAttr];
          });
        }
      }
      if (this.state.filterable === 'false') {
        this.props.onSortChange(data);
      } else {
        const self = this;
        setTimeout(() => {
          self.setState({ posts: [] });
          self.setState({ posts: newPosts });
        }, 5);
      }
    }
    handleLoadMore() {
      const { pageNumber } = this.state;
      if (this.state.filterable === false) {
        this.setState({ pageNumber: pageNumber + 1 });
        this.props.onChangePagination(pageNumber + 1);
      } else {
        let loadedItem = parseInt(this.state.loadedItem, 10);
        const gridIndex = findIndex(this.props.allLayout, { type: 'grid' });
        if (gridIndex !== -1 && this.props.allLayout[gridIndex].hasOwnProperty('numberOfPosts')) {
          const numberOfPosts = 'numberOfPosts';
          this.setState({ loadedItem: parseInt(this.props.allLayout[gridIndex].numberOfPosts, 10) });
          loadedItem += parseInt(this.props.allLayout[gridIndex].numberOfPosts, 10);
        } else {
          loadedItem += 5;
        }
        this.setState({ loadedItem });
      }
    }
    render() {
      let displayItemNo = parseInt(this.props.block.numberOfPosts, 10);
      const pageNumber = this.state.pageNumber;
      const { settingsData } = this.props;

      const topbar = this.props.block.topbar ? this.props.block.topbar : {};
      const bottombar = this.props.block.bottombar ? this.props.block.bottombar : {};
      const barData = this.props.block.bardata ? this.props.block.bardata : {};
      let topbarpagination = false;
      let bottompagination = false;
      let showBottomBar = false;
      let bottomloadMore = false;

      if ('topbarpagination' in topbar) {
        topbarpagination = topbar.topbarpagination;
      }
      if ('bottompagination' in bottombar) {
        bottompagination = bottombar.bottompagination;
        showBottomBar = bottombar.bottombar;
      }
      if ('bottomloadMore' in bottombar) {
        bottomloadMore = bottombar.bottomloadMore;
        showBottomBar = bottombar.bottombar;
      }

      if (!displayItemNo) {
        displayItemNo = 10;
      }
      const posts = this.state.posts ? this.state.posts : [];
      let paginatedItem = [];
      let start = null;
      let pageLimit = null;
      let isDisabled = null;
      if (posts.length !== 0) {
        if (this.props.settingsData.ajax === 'false') {
          if (topbarpagination === 'true' || bottompagination === 'true') {
            start = ((pageNumber - 1) * displayItemNo);
            for (let index = start; (index < (start + displayItemNo)) && (posts.length > index); index++) {
              paginatedItem.push(posts[index]);
            }
            pageLimit = parseInt(((posts.length) / displayItemNo), 10) + (posts.length % displayItemNo !== 0 ? 1 : 0);
            if (displayItemNo > posts.length) {
              paginatedItem = clone(posts);
            }
          } else if (bottomloadMore === 'true') {
            pageLimit = parseInt(((posts.length) / displayItemNo), 10) + (posts.length % displayItemNo !== 0 ? 1 : 0);
            for (let index = 0; (index < parseInt(this.state.loadedItem, 10)) && (posts.length > index); index++) {
              paginatedItem.push(posts[index]);
            }
            isDisabled = paginatedItem.length === posts.length ? true : false;
          } else {
            pageLimit = parseInt(((posts.length) / displayItemNo), 10) + (posts.length % displayItemNo !== 0 ? 1 : 0);
            for (let index = 0; (index < displayItemNo) && (posts.length > index); index++) {
              paginatedItem.push(posts[index]);
            }
          }
        } else {
          paginatedItem = posts;
          pageLimit = Math.ceil(parseInt(this.props.total, 10) / displayItemNo);
        }
      }

      const paginationOption = {
        totalPage: pageLimit,
        selectPage: this.changePage,
        startPage: this.state.pageNumber,
      };

      let showLoadMoreButton = true;

      if (paginatedItem.length === parseInt(this.props.total, 10)) {
        showLoadMoreButton = false;
      }

      const loadMoreOption = {
        className: barData.bottombar_loadmore,
        disabled: isDisabled,
        onClick: this.handleLoadMore,
        show: showLoadMoreButton,
      };
      const ThemeComponent = window.ReactiveTheme[settingsData.theme] ? window.ReactiveTheme[settingsData.theme].bar : '';
      if (bottomloadMore) {
        paginatedItem = this.state.previousPosts.concat(paginatedItem);
      }
      const ifOpen = this.props.isToggle ? 'active ' + 'rq-grid-container' : '';
      return (<div className={ifOpen}>
        { this.props.isToggle ? <div> { <TopBarBlock {...this.props} barData={barData} results={parseInt(this.props.total, 10)} onListenTopBlock={this.handleListenTopBar.bind(this)} /> }
          {pageNumber <= pageLimit ?
          <div className="rq-reactive-builder flex-row">
            { paginatedItem.length && topbarpagination === 'true' ? <div className="flex-xs-12 top-bar-pagination"><ThemeComponent.topbarPagniation className={barData.topbar_pagination} {...paginationOption} /></div> : null}

              { paginatedItem.length ? paginatedItem.map(this.showAllPosts) : null }

            { paginatedItem.length && showBottomBar === 'true' && bottompagination === 'true' ? <div className="flex-xs-12 "><ThemeComponent.bottombarPagination className={barData.bottombar_pagination} {...paginationOption} /></div> : null}
          </div> : null}
          { bottomloadMore === 'true' ? <ThemeComponent.bottomLoadMore {...loadMoreOption} /> : null
          } </div> : null
        }
      {this.state.showAnimatedMsg === 0 ?
        <div className="rq-no-post-found">
          <i className="fa fa-frown-o"></i>
            <h3>{API.LANG.FOF}</h3>
        </div>
       : null}
       <div id="LoadTime" style={{ display: 'none' }}>
        <img src={API.IMG + 'loader.png'} alt=""/>
       </div>
      </div>
      );
    }
}

GridBlock.propTypes = {
  'previewOption': React.PropTypes.object,
  'urlData': React.PropTypes.object,
  'settingsData': React.PropTypes.object,
  'onChangePagination': React.PropTypes.func,
  'onSortChange': React.PropTypes.func,
  'allLayout': React.PropTypes.array,
  'block': React.PropTypes.object,
  'previewData': React.PropTypes.object,
  'helperData.posts': React.PropTypes.object,
  'helperData.posts.data': React.PropTypes.array,
  'shortcodeKey': React.PropTypes.number,
  'uid': React.PropTypes.string,
  'total': React.PropTypes.node,
  'isToggle': React.PropTypes.bool,
};

GridBlock.defaultProps = {
  'previewOption': {
    'posts': {
      'data': [],
    },
  },
};

export default GridBlock;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/preview/block/gridBlock.js
 **/